import React from "react"
import ReactDOM from "react-dom"
import CssBaseline from "@material-ui/core/CssBaseline"
import { ColorModeProvider } from "./layout/themeContext"

import "@fontsource/roboto/300.css"
import "@fontsource/roboto/400.css"
import "@fontsource/roboto/500.css"
import "@fontsource/roboto/700.css"

import App from "./App"
import { iniciarMonitoramentoWebVitals } from "./utils/reportarWebVitals"
import { C_SERVICE_WORKER_SHELL } from "./constants/serviceWorker"

ReactDOM.render(
  <ColorModeProvider>
    <CssBaseline>
      <App />
    </CssBaseline>
  </ColorModeProvider>,

  document.getElementById("root"),
)

iniciarMonitoramentoWebVitals()

if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register(C_SERVICE_WORKER_SHELL).catch(() => {})
  })
}
